/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Process_Step3_TitleInputs */

const et_process_step3_title = /** @type {(inputs: Process_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03. 90-päevane Sprint`)
};

const en_process_step3_title = /** @type {(inputs: Process_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03. 90-Day Sprint`)
};

/**
* | output |
* | --- |
* | "03. 90-Day Sprint" |
*
* @param {Process_Step3_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const process_step3_title = /** @type {((inputs?: Process_Step3_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Process_Step3_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_process_step3_title(inputs)
	return en_process_step3_title(inputs)
});